module.exports = __webpack_public_path__ + "media/images/posts/contract-5e9861eb1fdc8ab46eae15bc07d45b00.jpg";